import { IApplicationState } from '../types/redux';
import { hasValidPhone } from '../utils/agent';

export const buildersSelector = (state: IApplicationState) => {
  return state.newbuilding.builders;
};

export function buildersWithPhonesSelector(state: IApplicationState) {
  const {
    newbuilding: { builders },
  } = state;

  if (builders) {
    return builders.filter(builder => builder.showPhone && builder.phone);
  }

  return [];
}

export function buildersWithValidPhonesSelector(state: IApplicationState) {
  const builders = buildersSelector(state);

  return builders.filter(hasValidPhone);
}
